import { render } from "./baseEX.vue?vue&type=template&id=b8ff0890"
import script from "./baseEX.vue?vue&type=script&lang=js"
export * from "./baseEX.vue?vue&type=script&lang=js"

import "./baseEX.vue?vue&type=style&index=0&id=b8ff0890&lang=less"

import exportComponent from "D:\\myWorkspace\\CoreWeb\\MyNews\\ClientApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__